import { Fuel } from "lucide-react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
} from "recharts";

const AEFuelConsChart = ({aeFuelConsData}) => {
  console.log("aeFuelConsData:", aeFuelConsData);
  const staticRemainingFuel = {
    hfo: 0,
    lfo: 0,
    mgo: 0,
    others: 0,
  };

  const latestRecord =
    aeFuelConsData?.auxEngine && aeFuelConsData.auxEngine.length > 0
      ? aeFuelConsData.auxEngine[0]
      : null;

  const dynamicFuel = latestRecord?.fuelConsumption || {};

  const remainingFuel = {
    hfo: dynamicFuel.hfo ?? staticRemainingFuel.hfo,
    lfo: dynamicFuel.lfo ?? staticRemainingFuel.lfo,
    mgo: dynamicFuel.mgo ?? staticRemainingFuel.mgo,
    others: dynamicFuel.biofuel ?? staticRemainingFuel.others,
  };

  const colors = ["#1a5276", "#27ae60", "#d35400", "#7d3c98"];

  const axisLabelMap = {
    hfo: "Heavy Fuel Oil",
    lfo: "Light Fuel Oil",
    mgo: "Marine Gas Oil",
    others: "Others",
  };

  const tooltipLabelMap = {
    hfo: "Heavy Fuel Oil",
    lfo: "Light Fuel Oil",
    mgo: "Marine Gas Oil",
    others: "Others",
  };

  const data = Object.entries(remainingFuel).map(([key, value], index) => ({
    name: axisLabelMap[key] || key,
    tooltipName: tooltipLabelMap[key] || axisLabelMap[key] || key,
    value,
    color: colors[index % colors.length],
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;

    const data = payload[0].payload;
    const value = payload[0].value;
    const valueColor = data.color;

    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          border: "1px solid #e2e8f0",
          boxShadow: "rgba(0, 0, 0, 0.12) 0px 4px 12px",
          padding: "10px 14px",
          fontSize: "13px",
        }}
      >
        <div style={{ color: "#1e293b", fontWeight: 600, marginBottom: 4 }}>
          {data.tooltipName}
        </div>
        <div style={{ color: valueColor, fontWeight: 600 }}>{value} MT</div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
            <Fuel className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Fuel Consumption
            </h2>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="p-4">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={data}
            margin={{ top: 30, right: 30, left: 10, bottom: 20 }}
          >
            <XAxis
              dataKey="name"
              type="category"
              tick={{ fontSize: 12 }}
              tickMargin={10}
              interval={0}
              height={70}
            />
            <YAxis
              type="number"
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
              unit=" MT"
            />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: "#f1f5f9" }} />

            <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={50}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AEFuelConsChart;
